/** @file REST client for the session-only settings routes: API tokens (list, create, revoke) and password. */
import type { Scope } from '@pose2d/api/types';
import type { FetchLike } from './createApiClient';
import { requestApi } from './requestApi';
import type { CreatedToken, TokenInfo } from './sessionTypes';

const TOKENS = '/api/v1/settings/tokens';

/** Typed calls; a created token's secret exists only in createToken's answer. */
export function createSettingsApi(fetchFn: FetchLike) {
  return {
    listTokens: () => requestApi(fetchFn, 'GET', TOKENS) as Promise<{ tokens: TokenInfo[] }>,
    createToken: (name: string, scopes: Scope[]) => requestApi(fetchFn, 'POST', TOKENS, { name, scopes }) as Promise<CreatedToken>,
    revokeToken: (id: string) => requestApi(fetchFn, 'POST', `${TOKENS}/${encodeURIComponent(id)}/revoke`) as Promise<{ token: TokenInfo }>,
    changePassword: (current: string, next: string) => requestApi(fetchFn, 'POST', '/api/v1/settings/password', { current, next }) as Promise<undefined>,
  };
}

/** The settings REST client (see createSettingsApi). */
export type SettingsApi = ReturnType<typeof createSettingsApi>;
